import { Container, Row, Col } from "react-bootstrap";
import Shopintegrate from "../../components/shop_integrate";

const Useditemintegrate = () => {
  return (
    <>
      <Container>
        <div className="screenHeight">
          <Shopintegrate
            newshop="/used-items-form"
            url="/useditems-integrate-form"
          />
        </div>
      </Container>
    </>
  );
};

export default Useditemintegrate;
